import { useRef, useCallback, useEffect } from 'react';

import {
  CloseIcon,
  ContentWrapper,
  ErrorIcon,
  LeftIconWrapper,
  SnackbarWrapper,
  SuccessIcon,
} from './Snackbar.style';
import { SnackbarProps } from './Snackbar.types';

function Snackbar({
  children,
  onClose,
  shouldShowCloseButton,
  type,
  autoHideDuration = 5000,
}: SnackbarProps): JSX.Element | null {
  const timerAutoHide = useRef<NodeJS.Timeout>();

  const setAutoHideTimer = useCallback(
    (autoHideDurationParam) => {
      if (!autoHideDurationParam) {
        return;
      }

      if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
      timerAutoHide.current = setTimeout(() => {
        onClose();
      }, autoHideDurationParam);
    },
    [onClose],
  );

  useEffect(() => {
    setAutoHideTimer(autoHideDuration);
    return () => {
      if (timerAutoHide.current) clearTimeout(timerAutoHide.current);
    };
  }, [autoHideDuration, setAutoHideTimer]);

  return (
    <SnackbarWrapper type={type}>
      <LeftIconWrapper>
        {type === 'success' ? (
          <SuccessIcon type={type} />
        ) : (
          <ErrorIcon type={type} />
        )}
      </LeftIconWrapper>

      <ContentWrapper type={type}>{children}</ContentWrapper>

      {shouldShowCloseButton && <CloseIcon type={type} onClick={onClose} />}
    </SnackbarWrapper>
  );
}

export { Snackbar };
